import $ from "jquery";
import "select2";
import translations from "select2/src/js/select2/i18n/sl";
import { OTHER } from "./formHelpers";
import { highlightText } from "./textUtils";

export const DEFAULT_OPTIONS = {
  width: "style",
  language: translations,
  theme: "tailwindcss-4",
};

/**
 * Wraps DRF results in results, add pagination.
 */
export const processResults = (data, params) => {
  if (data.results) {
    const results = {
      pagination: {
        more: !!data.next,
      },
      results: data.results,
    };
    return results;
  } else {
    return { results: data };
  }
};

export function initializeSelect2(el) {
  const $el = $(el);

  //skip fields which names contains __prefix__
  const fieldName = $el.attr("name");
  if (fieldName && fieldName.indexOf("__prefix__") !== -1) {
    return;
  }

  const passFields = ($el.attr("data-pass-fields") || "")
    .split(",")
    .filter((e) => e !== "");
  const $form = $el.closest("form");
  let currentTerm = "";

  const opts = {
    ...DEFAULT_OPTIONS,
    minimumInputLength: 0,
    allowClear: true,
    placeholder: $el.attr("data-placeholder"),
    containerCssClass: "form-control",
    templateResult: (state) => {
      return state.loading
        ? state.text
        : $(`<span>${highlightText(state.text, currentTerm)}</span>`);
    },
  };
  if (el.dataset.url) {
    const otherLabel = el.dataset.otherLabel;
    opts.ajax = {
      url: el.dataset.url,
      dataType: "json",
      data: (params) => {
        currentTerm = params.term;
        const query = {
          ...params,
        };
        passFields.forEach(
          (key) => (query[key] = $(`[name=${key}]`, $form).val()),
        );
        return query;
      },
      processResults: otherLabel
        ? (data, params) => {
            const result = processResults(data, params);
            result.results.push({ id: OTHER, text: otherLabel });
            return result;
          }
        : processResults,
    };
  }
  $el.select2(opts);
}
